export default __webpack_public_path__ + "static/media/profilephoto.d35be98d.JPG";